
import _ from 'lodash';
import Vue, {PropOptions} from 'vue';

import PhotoPreview from '~/components/misc/PhotoPreview.vue'

export default Vue.extend({
  components: {
    PhotoPreview: PhotoPreview
  },
  props: {
    photo_gallery: {
      type: Array,
      required: true
    } as PropOptions<GalleryPhoto[]>,
    max_number_of_photos: {
      type: Number,
      default: 3,
    } as PropOptions<number>,
    editable: {
      type: Boolean,
      default: false,
    } as PropOptions<boolean>,
  },
  methods: {
    range(n: number) {
      return _.range(n);
    },
    confirm(message: string) {
      return confirm(message);
    },
    getPhotoRelativeToPhoto(photo: GalleryPhoto, relative: number) {
      const index = _.findIndex(this.orderedPhotos, e => e.photo_id === photo.photo_id);
      let newIndex = index + relative;

      if(newIndex >= this.orderedPhotos.length) {
        newIndex = 0;
      } else if(newIndex < 0) {
        newIndex = this.orderedPhotos.length - 1;
      }

      return this.orderedPhotos[newIndex];
    }
  },
  computed: {
    orderedPhotos() {
      return _.sortBy(this.photo_gallery, 'created_at');
    },
    numEmptySlots() {
      const slots = this.max_number_of_photos - this.photo_gallery.length;
      return slots >= 0 ? slots : 0;
    },
    numEmptySlotsMinus1() {
      // @ts-ignore
      // const value = this.editable ? this.numEmptySlots - 1 : this.numEmptySlots;
      const value = this.numEmptySlots - 1;
      return value >= 0 ? value : 0;
    }
  }
})
